export { default as Divider } from './component';
export type { Props as DividerProps } from './types';
